"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecaptchaAdjuster = void 0;
const react_1 = require("react");
/*
 $screen-laptop = 1024px
 screens.scss
 */
const MAX_BOTTOM = 111;
const SCREEN_LAPTOP = 1024;
const BADGE = '.grecaptcha-badge';
const LAYOUT_ID = '#layout-services';
const RecaptchaAdjuster = () => {
    (0, react_1.useEffect)(() => {
        const getMaxScroll = () => Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const attach = (badge) => {
            const update = () => {
                const y = window.scrollY;
                const max = getMaxScroll();
                const isMobile = window.innerWidth < SCREEN_LAPTOP;
                if (max <= 0 || !isMobile) {
                    badge.style.bottom = `${MAX_BOTTOM}px`;
                    badge.style.zIndex = '50';
                    return;
                }
                const start = MAX_BOTTOM - max;
                const bottom = start + (MAX_BOTTOM - start) * (y / max);
                badge.style.bottom = `${bottom}px`;
                badge.style.zIndex = '49';
            };
            requestAnimationFrame(update);
            window.addEventListener('scroll', update, { passive: true });
            window.addEventListener('resize', update);
            return () => {
                window.removeEventListener('scroll', update);
                window.removeEventListener('resize', update);
            };
        };
        const tryAttach = () => {
            const badge = document.querySelector(BADGE);
            return badge ? attach(badge) : null;
        };
        let attachedCleanup = null;
        const setupForLayout = () => {
            attachedCleanup === null || attachedCleanup === void 0 ? void 0 : attachedCleanup();
            const layout = document.querySelector(LAYOUT_ID);
            if (layout)
                attachedCleanup = tryAttach();
        };
        const mo = new MutationObserver(() => setupForLayout());
        mo.observe(document.body, { childList: true, subtree: true });
        setupForLayout();
        return () => {
            mo.disconnect();
            attachedCleanup === null || attachedCleanup === void 0 ? void 0 : attachedCleanup();
        };
    }, []);
    return null;
};
exports.RecaptchaAdjuster = RecaptchaAdjuster;
